import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { bundleKeys } from "./bundle-keys";

// CLAUDE.md rule 4: type from BE schema, not hand-rolled.
export type UpdateBundleBody = components["schemas"]["UpdateListingRequest"];

interface UpdateBundleVars {
  code: string;
  body: UpdateBundleBody;
}

export function useUpdateBundle() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ code, body }: UpdateBundleVars) => {
      const { error } = await apiClient.PATCH("/v1/listings/{code}", {
        params: { path: { code } },
        body,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: bundleKeys.all });
    },
  });
}
